const Footer = () => {
  return (
    <p className="clearfix mb-0">
      <span className="float-md-right d-block d-md-inline-block mt-25">
        © {new Date().getFullYear()} Bookla
      </span>
    </p>
  );
};

export default Footer;
